module.exports = __webpack_public_path__ + "img/白芍.daeb4707.jpg";